import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Globals } from "@foh/globals";
import { Router, ActivatedRoute } from "@angular/router";
import { ReservationformService } from "../reservationform/reservationform.service";
import * as alertFunctions from "@foh/shared/data/sweet-alerts";
import * as utils from "@foh/shared/services/utils";
import { CustomerauthService } from "@foh/shared/auth/customerauth.service";

@Component({
  selector: 'app-guest-loggedin-area',
  templateUrl: './guest-loggedin-area.component.html',
  styleUrls: ['./guest-loggedin-area.component.scss']
})
export class GuestLoggedinAreaComponent implements OnInit {
  imageSrc: string = null;
  routeObs$: any;
  formid: any;
  constructor(private reservationformService: ReservationformService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private globals: Globals,
    private customerauthService:CustomerauthService
    ) { }

    ngOnInit() {
      this.routeObs$ = this.activeRoute.params.subscribe(params => {
        this.formid = params["token"];
        this.reservationformService
          .retrieveMetadata(params)
          .subscribe((response: any) => {
            this.renderer.addClass(document.body, response.metaData.cssclass);
            this.imageSrc =
              this.globals.UPLOADS + "logos/" + response.metaData.logo;
          });
      });
    }

    signOut(){
        this.customerauthService.logout();
        this.router.navigate(["guest/login/"+this.formid]);
    }

}
